import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchReceipt } from 'store/actions/orderActions';
import styled from 'styled-components';
import { groupBy, map, snakeCase, sumBy } from 'lodash';

const Group = styled.div`
    margin: 0.75rem 0;
`;

const Box = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Text = styled.div`
    font-size: 14px;
    line-height: 1.5;

    ${ (props) => {
        if (props.bold) {
            return 'font-weight: bold;';
        }
    } }
`;

class BookingReceipt extends React.PureComponent {
    componentDidMount() {
        const { data, fetch, record: { id } } = this.props;

        if (utils.isEmpty(data)) {
            fetch({
                id: id,
            });
        }
    }

    formatToCurrency = (value) => {
        const { locale, record: { currency } } = this.props;
        const { config: { currency: { system } } } = this.context;

        const result = new Intl.NumberFormat(locale, {
            currency: currency || system,
            minimumFractionDigits: 2,
            style: 'currency',
        }).format(value);

        return result;
    }

    groupedDiscounts = (discounts) => {
        return map(groupBy(discounts, 'discount'), (discounts) => {
            return {
                ...discounts[0],
                amount: sumBy(discounts, 'amount'),
            };
        });
    }

    render() {
        const {
            data,
            loading,
            translate,
        } = this.props;

        if (loading) {
            return null;
        }

        return (
            <div>
                {
                    utils.map(data, (value, key) => {
                        if (key === 'discounts') {
                            return (
                                <Group key={ `${ key }` }>
                                    {
                                        utils.map(this.groupedDiscounts(value), (discount, index) => {
                                            return (
                                                <Box key={ `${ key }-${ discount['discount-token'] }-${ index }` }>
                                                    <Text>{ `${ discount.discount } ${ discount['discount-token'] ? `(${ discount['discount-token'] })` : '' }` }</Text>

                                                    <Text bold={ true }>{ this.formatToCurrency(discount.amount) }</Text>
                                                </Box>
                                            );
                                        })
                                    }
                                </Group>
                            );
                        }

                        if (key === 'subtotal_base' || key === 'subtotal_additional' || key === 'subtotal_discounts' || key === 'total') {
                            return (
                                <Group key={ `${ key }` }>
                                    <Box>
                                        <Text>{ translate(`resources.orders.receipt.${ key }`) }</Text>
                                        <Text>{ this.formatToCurrency(value) }</Text>
                                    </Box>
                                </Group>
                            );
                        }

                        return (
                            <Box key={ `${ key }_${ value }` }>
                                <Text>{ translate(`resources.orders.receipt.${ snakeCase(key) }`) }</Text>
                                <Text>{ this.formatToCurrency(value) }</Text>
                            </Box>
                        );
                    })
                }
            </div>
        );
    }
}

BookingReceipt.contextTypes = {
    config: PropTypes.object,
};

BookingReceipt.propTypes = {
    data: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    locale: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const { id } = props.record;

    return {
        data: state.orders.receipt.data[id],
        id: id,
        loading: state.orders.receipt.loading,
        locale: state.locale,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (values) => {
            dispatch(fetchReceipt(values));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(BookingReceipt);



// WEBPACK FOOTER //
// ./src/pages/bookings/show/BookingReceipt.js